import React, { useEffect, useState } from "react";
import authApiService from "../../services/authServices";
import { jwtDecode } from "jwt-decode";
import {
    readSelectedCityId,
    registrationEndCountdownDays,
} from "../../utils/registrationCountdown";

const NewSeason = () => {

    const [daysRemaining, setDaysRemaining] = useState(null);

    useEffect(() => {
        let cancelled = false;

        const loadCountdown = async () => {
            const cityId = readSelectedCityId();
            if (!cityId) {
                if (!cancelled) setDaysRemaining(null);
                return;
            }

            let userId = null;
            const token = localStorage.getItem("accessToken");
            if (token) {
                try {
                    const decoded = jwtDecode(token);
                    userId = decoded?.userId || null;
                } catch (e) {
                    userId = null;
                }
            }

            try {
                const res = await authApiService.post("homeBannerStatus", {
                    userId: userId ? String(userId) : null,
                    cityId: String(cityId),
                });

                if (cancelled) return;

                setDaysRemaining(
                    res?.code === 200 ? registrationEndCountdownDays(res?.data) : null
                );
            } catch (error) {
                console.error("Error loading city registration countdown:", error);
                if (!cancelled) setDaysRemaining(null);
            }
        };

        loadCountdown();
        window.addEventListener("cityChange", loadCountdown);
        window.addEventListener("storage", loadCountdown);
        return () => {
            cancelled = true;
            window.removeEventListener("cityChange", loadCountdown);
            window.removeEventListener("storage", loadCountdown);
        };
    }, []);

    const hasCountdown = typeof daysRemaining === "number" && daysRemaining >= 1;
    const dayLabel = daysRemaining === 1 ? "DAY" : "DAYS";

    return (
        <div className="col-sm-8">
            <div id="header-home">
                <div id="header-home-text">
                    {hasCountdown ? (
                        <span className="count-down font-weight-bold">
                            NEW SEASON STARTS IN{" "}
                            <span className="count-down-days">
                                {daysRemaining} {dayLabel}
                            </span>
                        </span>
                    ) : (
                        <span className="count-down font-weight-bold">
                            NEW SEASON COMING SOON
                        </span>
                    )}
                </div>
            </div>
            <div className="std-pad flu-box shadow lt-leader-mnht">
                <h3 className="def_col">Welcome to Open Play Tennis - Now Go Beat Someone New</h3>
                <p className="justify">
                    Let's face it, you're not qualifying for the Open this year, but you can still feel like you're playing in it. Open Play Tennis allows you to <strong>connect with players</strong> from across town or across the county. Open Play Tennis is about playing a guy named Joe. It's about sharing your most memorable highlights and commiserating your defeats <br></br><br></br>.Open Play Tennis is more user friendly, more intuitive, and has better functionality than anything focusing on amateur tennis. Register to play in the four-week regular season. <b>Play against players of your skill level</b>. Select your home court. <b>Set your own schedule </b>and track your progress on the leaderboard. Qualify for the two-week playoffs and who knows, you may just have bragging rights as city champion in perpetuity.<b> Now go beat Joe</b>.
                </p>
                <p className="p-0 m-0"><b> Ball Boys Optional </b></p>
            </div>
        </div>
    );
};

export default NewSeason
